import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Intervencion/addIntervencion`, method: 'POST', body: values, token: token})
}
